import { Card, Space } from 'antd';
import React from 'react';
import { SubSubtitle, Title } from '.';
import ResponsiveContainer from './ResponsiveContainer';

const TerminosCondiciones = () => {
  return (
    <>
      <ResponsiveContainer>
        <Card
          style={{
            margin: '0 auto',
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <Space size="large" direction="vertical">
            <Title>Términos y Condiciones</Title>
            <p style={{ textAlign: 'start' }}>
              Por el presente se establecen los términos y condiciones generales
              (los &quot;Términos y Condiciones Generales&quot;) aplicables al
              uso de la Plataforma (&quot;Plataforma&quot; o el
              &quot;Sitio&quot;). Cualquier persona (en adelante
              &quot;Usuario&quot; o en plural &quot;Usuarios&quot;) que acceda
              y/o use la Plataforma deberá hacerlo sujetándose a estos Términos
              y Condiciones Generales, junto a todas las políticas y principios
              que rigen a al presente acuerdo y que son incorporados al presente
              por referencia.
            </p>
          </Space>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'start',
              alignItems: 'start'
            }}
          >
            <SubSubtitle>01 - Objeto.</SubSubtitle>
            <p style={{ textAlign: 'start' }}>
              La Plataforma facilita y permite al Usuario contratar vía web
              pólizas de seguros y servicios relacionados (Los “Servicios”) de
              terceras Empresas (“Empresas) que están debidamente habilitadas
              para operar y que son ofrecidas por parte del vendedor
              (“Vendedor”).
            </p>

            <SubSubtitle>02 - Capacidad.</SubSubtitle>

            <p style={{ textAlign: 'start' }}>
              Los Servicios sólo están disponibles para personas que tengan
              capacidad legal para contratar. No podrán utilizar los Servicios
              las personas que no tengan esa capacidad, los menores de edad y/o
              Usuarios de la Plataforma que hayan sido suspendidos temporalmente
              o inhabilitados definitivamente.
            </p>
            <SubSubtitle>03 - Uso de la Plataforma.</SubSubtitle>
            <p style={{ textAlign: 'start' }}>
              Para contratar Los Servicios ofrecidos a través de la plataforma,
              el usuario deberá completar todos los datos con información
              exacta, precisa y verdadera, por lo cual excluye de manera expresa
              de cualquier responsabilidad por la certeza o exactitud de los
              Datos Personales de los Usuarios.
            </p>
            <p style={{ textAlign: 'start' }}>
              Se podrá solicitar documentos y/o datos adicionales a efectos de
              corroborar los Datos Personales, así como de suspender temporal o
              definitivamente a aquellos Usuarios cuyos datos no hayan podido
              ser confirmados. En estos casos de inhabilitación, se dará de baja
              al Usuario sin que ello genere algún derecho a resarcimiento.
            </p>

            <SubSubtitle>04 - Privacidad de la Información.</SubSubtitle>
            <p style={{ textAlign: 'start' }}>
              Para utilizar los Servicios ofrecidos en la Plataforma, los
              Usuarios deberán facilitar determinados datos de carácter
              personal. Su información personal se procesa y almacena en medios
              que mantienen altos estándares de seguridad y protección
              tecnológica. La información provista por los Usuarios, será
              tratada conforme a lo dispuesto en la legislación vigente y con el
              compromiso de no difundir o publicar la misma.
            </p>

            <SubSubtitle>05 - Propiedad Intelectual.</SubSubtitle>

            <p style={{ textAlign: 'start' }}>
              Las partes aceptan el uso de la Plataforma de acuerdo a los
              términos y condiciones del presente acuerdo, entendiendo y
              reconociendo que los derechos por La Plataforma se encuentran
              protegidos por la legislación vigente en materia de propiedad
              intelectual y los tratados nacionales e internacionales de derecho
              de autor, marcas, patentes, modelos y diseños industriales.
            </p>
            <p style={{ textAlign: 'start' }}>
              El uso indebido y la reproducción total o parcial de dichos
              contenidos quedan prohibidos, salvo autorización expresa y por
              escrito de la Plataforma. No está permitida ninguna acción o uso
              de dispositivo, software, u otro medio tendiente a interferir
              tanto en las actividades y operatoria de la Plataforma como en las
              ofertas, descripciones, cuentas o bases de datos. Cualquier
              intromisión, tentativa o actividad violatoria o contraria a las
              leyes sobre derecho de propiedad intelectual y/o a las
              prohibiciones estipuladas en este contrato harán pasible a su
              responsable de las acciones legales pertinentes, y a las sanciones
              previstas por este acuerdo, así como lo hará responsable de
              indemnizar los daños ocasionados.
            </p>
            <SubSubtitle>
              06 - Sanciones. Suspensión de operaciones.
            </SubSubtitle>
            <p style={{ textAlign: 'start' }}>
              Sin perjuicio de otras medidas, la Plataforma podrá advertir,
              suspender en forma temporal o definitivamente a un Usuario,
              iniciar las acciones que estime pertinentes y/o suspender la
              prestación de sus Servicios si (a) se quebrantara alguna ley, o
              cualquiera de las estipulaciones de los Términos y Condiciones
              Generales y demás políticas; (b) si incumpliera sus compromisos
              como Usuario; (c) si se incurriera a criterio en conductas o actos
              dolosos o fraudulentos; (d) no pudiera verificarse la identidad
              del Usuario o cualquier información proporcionada por el mismo
              fuere errónea. En el caso de la suspensión de un Usuario, sea
              temporal o definitiva. En ninguno de estos casos el Usuario tendrá
              derecho a resarcimiento alguno.
            </p>
            <SubSubtitle>07 - Indemnidad.</SubSubtitle>
            <p style={{ textAlign: 'start' }}>
              La Plataforma se limita a ser un medio para ofrecer y facilitar a
              los Usuarios un espacio virtual para la contratación de seguros y
              servicios relacionados. La Plataforma no es el propietario de los
              servicios ofrecidos, ni los ofrece en venta. La plataforma no
              interviene en el perfeccionamiento de las operaciones realizadas
              entre los Usuarios ni en las condiciones por ellos estipuladas
              para las mismas, por ello no será responsable respecto de las
              condiciones de los servicios ofrecidos y adquiridos por los
              Usuarios. Las partes conocen y aceptan ser los exclusivos
              responsables por los Servicios ofrecidos para su venta.
            </p>

            <p style={{ textAlign: 'start' }}>
              La Plataforma no será responsable por el efectivo cumplimiento de
              las obligaciones asumidas por los Vendedores y las Empresas. El
              Usuario conoce y acepta que realiza operaciones con Vendedores y
              Empresas bajo su propia responsabilidad y deslindando a la
              Plataforma de cualquier responsabilidad respecto al Servicio
              contratado por el mismo. En ningún caso La Plataforma será
              responsable por lucro cesante, o por cualquier otro daño y/o
              perjuicio que haya podido sufrir una de las Partes, debido a las
              operaciones realizadas o no realizadas a través de la Plataforma.
            </p>
            <p style={{ textAlign: 'start' }}>
              En caso que un Usuario o algún tercero inicien cualquier tipo de
              reclamo o acciones legales contra un Vendedor o Empresa, el o los
              Usuarios involucrados en dichos reclamos o acciones eximen de toda
              responsabilidad a La Plataforma y a sus directores, gerentes,
              empleados, agentes, operarios, representantes y apoderados.
            </p>
            <SubSubtitle>08 - Independencia.</SubSubtitle>

            <p style={{ textAlign: 'start' }}>
              Se deja constancia de que no existe relación de dependencia ni
              subordinación alguna entre las Partes y que no están vinculadas
              por más derechos u obligaciones que las que surgen del presente
              contrato y que se trata de una relación comercial entre empresas
              independientes. Asimismo, las Partes establecen que en ningún
              momento existirá relación laboral ni subordinación alguna entre la
              Partes. En consecuencia, el personal de cada una de las Partes no
              será considerado subordinado de la otra en ningún sentido, siendo
              cada parte responsable por las obligaciones laborales, de
              seguridad social, derivadas de eventuales accidentes de trabajo y
              por toda otra obligación emanada de su relación con dicho
              personal.
            </p>

            <SubSubtitle>09 - Fallas en el sistema.</SubSubtitle>

            <p style={{ textAlign: 'start' }}>
              La Plataforma no se responsabiliza por cualquier daño, perjuicio o
              pérdida al usuario causados por fallas en el sistema, en el
              servidor o en Internet. La Plataforma tampoco será responsable por
              cualquier virus que pudiera infectar el equipo del usuario como
              consecuencia del acceso, uso o examen de su sitio web o a raíz de
              cualquier transferencia de datos, archivos, imágenes, textos, o
              audio contenidos en el mismo. Los usuarios NO podrán imputar
              responsabilidad alguna ni exigir pago alguno, en virtud de
              perjuicios resultantes de dificultades técnicas o fallas en los
              sistemas o en Internet. La Plataforma no garantiza el acceso y uso
              continuado o ininterrumpido de su sitio. El sistema puede
              eventualmente no estar disponible debido a dificultades técnicas o
              fallas de Internet, o por cualquier otra circunstancia ajena a La
              Plataforma; en tales casos se procurará restablecerlo con la mayor
              celeridad posible sin que por ello pueda imputársele algún tipo de
              responsabilidad. La Plataforma no será responsable por ningún
              error u omisión contenidos en su sitio web.
            </p>

            <SubSubtitle>10 - No Renuncia.</SubSubtitle>

            <p style={{ textAlign: 'start' }}>
              La falta o demora en el ejercicio de cualquier derecho, facultad o
              privilegio en virtud de los Términos y Condiciones no se
              considerará una renuncia al mismo, ni tampoco el ejercicio parcial
              de cualquier derecho, facultad o privilegio impedirá todo otro
              ejercicio del mismo, o el ejercicio de todo otro derecho, facultad
              o privilegio acordado en estos Términos y Condiciones. Los
              derechos y remedios aquí expuestos son acumulativos y no
              excluyentes de todo otro derecho o remedio dispuesto por la ley.
            </p>

            <SubSubtitle>11 - Modificaciones del Acuerdo.</SubSubtitle>

            <p style={{ textAlign: 'start' }}>
              Los Términos y Condiciones Generales en cualquier momento haciendo
              públicos en el Sitio los términos modificados con efecto
              inmediato.
            </p>

            <SubSubtitle>12 - Nulidad Parcial</SubSubtitle>

            <p style={{ textAlign: 'start' }}>
              La invalidez de alguna disposición de este contrato no afecta la
              validez del resto de las disposiciones y las partes interpretarán
              este contrato como si dicha disposición inválida no existiera.
              Ninguna disposición de este contrato podrá darse por terminada,
              modificarse o renunciarse excepto mediante convenio escrito
              suscrito por las partes.
            </p>

            <SubSubtitle>13 - Jurisdicción y Ley Aplicable.</SubSubtitle>

            <p style={{ textAlign: 'start' }}>
              Este acuerdo estará regido en todos sus puntos por las leyes
              vigentes en la República del Paraguay.
            </p>

            <p style={{ textAlign: 'start' }}>
              Cualquier controversia derivada del presente acuerdo, su
              existencia, validez, interpretación, alcance o cumplimiento, será
              sometida a los tribunales de la ciudad de Asunción Capital de la
              República del Paraguay, renunciando a cualquier otra jurisdicción
              que pudiera corresponder.
            </p>
          </div>
        </Card>
      </ResponsiveContainer>
    </>
  );
};

export default TerminosCondiciones;
